module.exports = __webpack_public_path__ + "img/heroku.d5b0e9c0.png";